import { Controller } from "@hotwired/stimulus"
import * as TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    new TomSelect.default(this.element, {
      onItemAdd: function() {
        this.setTextboxValue("")
      }
    })
  }

  get select() {
    return this.element.querySelector("select")
  }
}
